import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const PeopleLockfilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="peopleLockfilled" ref={ref} {...props}>
    <path d="M13.48,3.32a3.26,3.26,0,1,1-3.26,3.26A3.26,3.26,0,0,1,13.48,3.32Zm-2.15,8.15a4,4,0,0,0-4,4,.67.67,0,0,0,.67.67h5.71a3,3,0,0,1,1.45-2.12v-.7a3.22,3.22,0,0,1,.61-1.88h-4.4ZM3.24,7.91A2.45,2.45,0,1,0,5.69,5.46,2.45,2.45,0,0,0,3.24,7.91Zm3.31,3.67H4.92a3,3,0,0,0-3,3,.5.5,0,0,0,.5.5H4.81c.28,0,.82-.2.92-.5a7.29,7.29,0,0,1,.54-1.26,5.52,5.52,0,0,1,.47-.8A1,1,0,0,0,7,11.91.38.38,0,0,0,6.55,11.58Zm16.17,5.55v1.33a2.25,2.25,0,0,1-2.25,2.25H17.26A2.25,2.25,0,0,1,15,18.46V17.13a2.19,2.19,0,0,1,.53-1.44,2,2,0,0,1,.91-.66V13.82a1,1,0,0,1,0-.32A2.14,2.14,0,0,1,18,11.75a1.79,1.79,0,0,1,.64-.1h.47a2.17,2.17,0,0,1,2.14,1.85,1.35,1.35,0,0,1,0,.32V15A2.22,2.22,0,0,1,22.72,17.13Zm-2.95-3.3s0-.07,0-.1a.65.65,0,0,0-.66-.58h-.47a.44.44,0,0,0-.17,0,.68.68,0,0,0-.49.57.29.29,0,0,1,0,.09v1.05h1.82Z" />
  </Icon>
)) as IconWithRender;

PeopleLockfilledIcon.displayName = 'PeopleLockfilledIcon';
PeopleLockfilledIcon.renderIcon = (props) => (
  <PeopleLockfilledIcon {...props} />
);
export default PeopleLockfilledIcon;
